import * as React from "react";
import Component from "../../AbstractComponent";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import CompanyLookup from "../../Partials/Lookup/CompanyLookup";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { CoachDialog } from "../../Partials/Dialog/CoachDialog";
import { CoachPoaDialog } from  "../../Partials/Dialog/CoachPoaDialog";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import PropertyCreateWillMount from "../../../Middleware/Middlewares/PropertyCreateWillMount";
import { Attachment } from "../../Partials/Attachment/Attachment";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import * as uuidV4 from "uuid/v4";
import ChargeTemplateCard from "../../Partials/ChargeTemplate/ChargeTemplateCard";

class PropertyCreate extends Component {
  private disableOwnerId: number;
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_PROPERTY_CREATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    PropertyCreateWillMount,
    PreventPageLeave
  ];

  public state = {
    address: {
      formattedAddress: ""
    },
    selectedPerson: null,
    selectedCompany: null,
    property: null,
    companyId: "",
    company: {
      id: null,
      avatar: this.image.get("company"),
      displayName: ""
    },
    amazonFolderName: uuidV4(),
    note: "",
    openLeavePrompt: false,
    hasModifiedData: false,
    isSaving: false,
    nextPath: "",
    attachments: [],
    openPropertyOwnerCoachDialog: false,
    openPrePropertyOwnerCoachDialog: false,
    ownerType: "company",
    ownerTypeСhose: true,
    // charge templates
    chargeTemplates: [],
    isChargeTemplatePopupOpen: false,
    newChargeTemplatePopupOpen: null,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    isUpdating: false,
    removed: false,
    contactInformationOfAssociation: "",
    selectedAssociationOwner: null,
    defaultCompanyName: "",
    openPoaCoachDialog: false,
    defaultPoaCompanyName: "",
    complexName: ""
  };

  constructor(public props) {
    super(props);
  }

  public selectPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedPerson: person,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public selectCompany = (company: CompanyInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedCompany: company,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public selectAssociationOwner = (company: CompanyInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedAssociationOwner: company,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public clearPerson = (): void => {
    this.setState({
      selectedPerson: null,
      hasModifiedData: true
    });
  }

  public clearAssociationOwner = (): void => {
    this.setState({
      selectedAssociationOwner: null,
      hasModifiedData: true
    });
  }

  public clearCompany = (): void => {
    this.setState({
      selectedCompany: null,
      hasModifiedData: true
    });
  }

  public getCompanyLogo = (): string => {
    if (this.state.selectedCompany) {
      return this.state.selectedCompany.avatar;
    }

    return this.image.get("company");
  }

  public getPersonAvatar = (): string => {
    if (this.state.selectedPerson) {
      return this.state.selectedPerson.avatar;
    }

    return this.image.get("user");
  }

  public getPropertyLogo = (): string => {
    if (typeof this.state.property !== "undefined" && this.state.property !== null) {
      return this.state.property.avatar;
    }

    return this.image.get("property");
  }

  public save = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_PROPERTY_CREATE_START,
        payload: {
          property: {
            address: { ...this.state.address },
            companyId: !this.state.selectedCompany ? null : this.state.selectedCompany.id,
            managerId: !this.state.selectedPerson  ? null : this.state.selectedPerson.id,
            amazonFolderName: this.state.amazonFolderName,
            note: this.state.note,
            isDefaultUnit: !this.browser.history.getPreviousPage().includes("unit/create"),
            chargeTemplatesIds: [...this.state.chargeTemplates].map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate.id),
            contactInformationOfAssociation: this.state.contactInformationOfAssociation,
            associationOwnerId: this.state.selectedAssociationOwner ? this.state.selectedAssociationOwner.id : null,
            complexName: this.state.complexName
          }
        },
        onSuccess: (property: PropertyInterface) => {
          if (property) {
            return this.redirect(`/app/property/update/${property.id}`);
          }

          const savedDataBeforeRedirecting = {...this.props.app.savedDataBeforeRedirecting};

          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          savedDataBeforeRedirecting.createdProperty = property;

          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
            payload: {
              savedDataBeforeRedirecting: {...savedDataBeforeRedirecting}
            }
          });

          return this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public openChargeTemplateCreatePopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.setState({
      newChargeTemplatePopupOpen: true
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isChargeTemplatePopupOpen: false,
      isUpdating: false
    });
  }

  public openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface): void => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget
    });
  }

  public closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  public addChargeTemplate = (chargeTemplate, callback?): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_START,
      payload: {
        chargeTemplate: chargeTemplate,
        propertyId: null
      },
      onSuccess: createdChargeTemplate => {
        this.setState({
          isChargeTemplatePopupOpen: false,
          chargeTemplates: [...this.state.chargeTemplates, createdChargeTemplate]
        }, () => {
          if (typeof callback === "function") {
            callback();
          }
        });
      }
    });
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface): any => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      newChargeTemplatePopupOpen: false
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public updateChargeTemplate = (updatedChargeTemplate: ChargeTemplateInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_START,
      payload: {
        chargeTemplate: updatedChargeTemplate
      },
      onSuccess: updatedChargeTemplate => {
        this.setState({
          isChargeTemplatePopupOpen: false,
          chargeTemplates: this.state.chargeTemplates.map(
            (chargeTemplate: ChargeTemplateInterface) => {
              if (chargeTemplate.id === updatedChargeTemplate.id) {
                return chargeTemplate.reinitialize({...updatedChargeTemplate.data});
              }

              return chargeTemplate;
            }
          )
        });
      }
    });
  }

  public deleteChargeTemplate = (chargeTemplate: ChargeTemplateInterface): any => {
    this.closeChargeTemplateMenu();

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_START,
      payload: {
        chargeTemplate: chargeTemplate
      },
      onSuccess: deletedChargeTemplate => {
        this.setState({
          chargeTemplates: [...this.state.chargeTemplates]
                             .filter(chargeTemplate => chargeTemplate.id !== deletedChargeTemplate.id)
        })
      }
    });
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={"property"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={this.closeChargeTemplatePopup}
          disabled={this.state.removed}
          showInformationText={true}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={"property"}
        selectedType={TypeContainer.pickIdFromLabel("Owner_association_contribution")}
        onSave={this.addChargeTemplate}
        onCancel={this.closeChargeTemplatePopup}
        showInformationText={true}
        company={this.state.selectedAssociationOwner}
      />
    );
  }

  public getChargeTemplates = () => {
    return [...this.state.chargeTemplates]
      .map((chargeTemplate: ChargeTemplateInterface) => {
        return (
          <TableRow
            hover
            key={chargeTemplate.id}
            className={`clickable-entity`}
            onClick={() => {
              this.openChargeTemplateUpdatePopup(chargeTemplate);
            }}
          >
            <TableCell></TableCell>
            <TableCell style={{width:"20%"}}>
              {this.formatter.formatNumber(chargeTemplate.amount, chargeTemplate.currency)}
            </TableCell>
            <TableCell style={{width:"15%"}}>{this.formatter.checkTranslationType(this.trans(chargeTemplate.repeatPeriod.label), chargeTemplate.repeatPeriod.label)}</TableCell>
            <TableCell style={{width:"20%"}}>{this.formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{width:"5%"}}>{chargeTemplate?.isPaidDirectlyToOwner ? this.trans("label-direct") : ""}</TableCell>
            <TableCell style={{width:"20%"}}>{chargeTemplate.description}</TableCell>
            <TableCell style={{width:"15%"}}>{this.formatter.formatDate(chargeTemplate.dueDateFirstPayment) || this.formatter.formatDate(chargeTemplate.firstDate)}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeTemplate && this.state.selectedChargeTemplate.id === chargeTemplate.id}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public chooseOwnerType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      ownerType: choice,
      ownerTypeСhose: true
    });
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/propertyowner-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.ownerType}
            onChange={this.chooseOwnerType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/propertyowner-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/propertyowner-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        <div className="hint-styles">
          {this.trans("coach/propertyowner-scenario/company-step/first-info2")}
        </div>
      </div>
    )
  }

  public onChangeContactInformationOfAssociation = (event) => {
    this.setState({
      contactInformationOfAssociation: event.target.value,
    })
  }

  public onCloseCoach = () => {
    this.setState({
      openPropertyOwnerCoachDialog: false,
      openPrePropertyOwnerCoachDialog: false,
      defaultCompanyName: "",
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public onClosePoaCoach = () => {
    this.setState({
      openPoaCoachDialog: false,
      defaultPoaCompanyName: "",
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public setCompanyFromCoach = (company) => {
    this.setState({
      selectedCompany: company
    })
  }

  public setPoaCompanyFromCoach = (company) => {
    this.setState({
      selectedAssociationOwner: company
    })
  }

  public openFirstStep = () => {
    this.setState({
      openPropertyOwnerCoachDialog: false,
      openPrePropertyOwnerCoachDialog: true,
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public selectEntityName = (name, type) => {
    this.setState({
      defaultCompanyName: type === "owner" ? name : "",
      defaultPoaCompanyName: type === "company" ? name : "",
    })
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("new-address")}</h1>
              <div className="button-container">
                <Button
                  color="primary"
                  onClick={this.redirectBack}
                  style={{marginRight: "20px"}}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.isSaving === true}
                  onClick={this.save}
                >
                  {this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-property-create">
            <div className="component-wrapper no-margin-top">
              <div className="component">
                <Card className="card">
                  <div style={{maxWidth: "420px", padding: "10px 40px 10px 10px"}}>
                    <form>
                      <AddressSelector
                        {...this.props}
                        autoFocus={true}
                        name="address.googlePlaceId"
                        className="scroll-to-address"
                        searchText={this.state.address.formattedAddress ? this.state.address.formattedAddress : null}
                        selectedAddress={this.state.address}
                        onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
                        onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", {})}
                        required={true}
                        error={this.getErrorFor("address.googlePlaceId")}
                      />

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-complexName"
                        type="text"
                        label={this.trans("label-complex-name") + this.trans("field/optional")}
                        value={this.state.complexName}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "complexName")}
                        variant="standard"
                        error={!!this.getErrorFor("complexName")}
                        helperText={this.getErrorFor("complexName")}
                      />

                      <div style={{margin: "-14px 0"}}>
                        <CompanyLookup
                          {...this.props}
                          id="companyId"
                          name="companyId"
                          className="scroll-to-companyId"
                          forceUpdatePage={true}
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          autoSelectId={this.state.selectedCompany && this.state.selectedCompany.id}
                          ref="CompanyLookup"
                          floatingLabelText={this.trans("dropdown-searchforowner-label")}
                          labelText={this.trans("dropdown-owner-label")}
                          buttonLabel={this.trans("dropdown-button-new-owner")}
                          searchText={this.state.company ? this.state.company.displayName : ""}
                          onSelect={this.selectCompany}
                          onClear={this.clearCompany}
                          selectEntityName={this.selectEntityName}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "propertyCreate", "owner" )}
                          noResultText={this.trans("dropdown-owner-notfound")}
                          error={this.getErrorFor("companyId")}
                          templateFor={"owner"}
                          shouldOpenCoachModal={true}
                          filterAgency={true}
                          openPropertyOwnerCoachDialog={() => this.setState({openPrePropertyOwnerCoachDialog: true})}
                          disabled={this.disableOwnerId > 0}
                        />
                      </div>

                      <div style={{margin: "-14px 0"}}>
                        <PersonLookup
                          {...this.props}
                          id="managerId"
                          name="managerId"
                          forceUpdatePage={true}
                          autoSelectId={this.state.selectedPerson && this.state.selectedPerson.id}
                          ref="PersonLookup"
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          floatingLabelText={this.trans("dropdown-searchformanager-label") + this.trans("field/optional")}
                          labelText={this.trans("dropdown-manager-label") + this.trans("field/optional")}
                          filter={true}
                          onSelect={this.selectPerson}
                          onClear={this.clearPerson}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "propertyCreate")}
                          buttonLabel={this.trans("dropdown-button-newmanager")}
                          noResultText={this.trans("dropdown-manager-notfound")}
                          showAdmins={false}
                          templateFor={"caretaker"}
                        />
                      </div>

                      <div style={{margin: "-14px 0"}}>
                        <CompanyLookup
                          {...this.props}
                          id="companyId"
                          name="companyId"
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          // className="scroll-to-companyId"
                          forceUpdatePage={true}
                          autoSelectId={this.state.selectedAssociationOwner && this.state.selectedAssociationOwner.id}
                          ref="CompanyLookup"
                          floatingLabelText={this.trans("page/propertycreate-field/associationownerid-label") + this.trans("field/optional")}
                          labelText={this.trans("page/propertycreate-field/associationownerid-label")}
                          searchText={this.state.company ? this.state.company.displayName : ""}
                          onSelect={this.selectAssociationOwner}
                          onClear={this.clearAssociationOwner}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "propertyCreate", "associationOwner")}
                          noResultText={this.trans("dropdown-company-notfound")}
                          selectEntityName={this.selectEntityName}
                          // error={this.getErrorFor("companyId")}
                          templateFor={"company"}
                          filterAgency={true}
                          buttonLabel={this.trans("dropdown/company-button/propertyassociation")}
                          shouldOpenCoachModal={true}
                          openPoaCoachDialog={() => this.setState({openPoaCoachDialog: true})}
                        />
                      </div>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-contactInformationOfAssociation"
                        type="text"
                        label={this.trans("page/propertycreate-field/contactInformationOfAssociation-label") + this.trans("field/optional")}
                        value={this.state.contactInformationOfAssociation}
                        onChange={this.onChangeContactInformationOfAssociation}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        error={!!this.getErrorFor("contactInformationOfAssociation")}
                        helperText={this.getErrorFor("contactInformationOfAssociation")}
                      />

                      <TextField
                        id="note"
                        name="note"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                        helperText={this.getErrorFor("note")}
                      />
                    </form>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper no-shadow">
              <Card className="card no-padding">
                <div className="label-container no-border" style={{backgroundColor: "#f9f9f9", height: "59px"}}>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={this.openChargeTemplateCreatePopup}
                    style={{
                      margin: "0 40px 0 0",
                      padding: "0 10px",
                      height: "50px"
                    }}
                  >
                    {this.trans("button-add-charge-template")}
                  </Button>
                </div>
                <div>    
                  {
                    this.state.chargeTemplates
                      .map((chargeTemplate: ChargeTemplateInterface, index: number) => {
                        return (
                          <div className="component-wrapper no-margins has-margin-bottom">
                            <div className="component">
                              <ChargeTemplateCard 
                                key={`chargeTemplate-${chargeTemplate?.id}`}  
                                chargeTemplate={chargeTemplate} 
                                openChargeTemplate={() => this.setState({selectedChargeTemplate: chargeTemplate, selectedChargeIndex: index}, () => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate))}
                                removeChargeTemplate={() => this.setState({selectedChargeTemplate: chargeTemplate, selectedChargeIndex: index}, () => this.deleteChargeTemplate(this.state.selectedChargeTemplate))}
                              />
                            </div>
                          </div>
                        );
                      })
                    }
                </div>
              </Card>
            </div>

            <div className="component-wrapper">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                possibilityToSetAvatar={true}
                title={this.trans("attachments-for-address")}
                relation="propertyId"
                onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                  this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                attachments={this.state.attachments}
                onCreate={attachments => this.setState({attachments: attachments})}
                updateParentState={attachments => this.setState({attachments: attachments})}
                onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                hint={this.trans("page/property-section/attachment-hint")}
              />
            </div>
          </div>
        </div>

        <CoachDialog
          {...this.props}
          openPropertyOwnerCoachDialog={this.state.openPropertyOwnerCoachDialog}
          type={this.state.ownerType}
          onCloseCoach={this.onCloseCoach}
          openFirstStep={this.openFirstStep}
          defaultCompanyName={this.state.defaultCompanyName}
          setCompanyFromCoach={this.setCompanyFromCoach}
        />

        <CoachPoaDialog
          {...this.props}
          openPoaCoachDialog={this.state.openPoaCoachDialog}
          type={"company"}
          onClosePoaCoach={this.onClosePoaCoach}
          defaultPoaCompanyName={this.state.defaultPoaCompanyName}
          setPoaCompanyFromCoach={this.setPoaCompanyFromCoach}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/propertyowner-title")}
          innerDialogClasses="coach-owner dialog-assistant"
          content={this.getCoachContent()}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPrePropertyOwnerCoachDialog}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              openPrePropertyOwnerCoachDialog: false,
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={() => { this.setState({ openPrePropertyOwnerCoachDialog: false, openPropertyOwnerCoachDialog: true }); }}
          diableContinueButton={!this.state.ownerTypeСhose}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.state.newChargeTemplatePopupOpen ? this.trans("title-property-new-price") : this.trans("title-property-price")}
          content={this.getChargeTemplatePopupContent()}
          openLeavePrompt={this.state.isChargeTemplatePopupOpen}
          onClose={this.closeChargeTemplatePopup}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.propertyCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  PropertyCreate
);
